import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { AppRouter } from './app/router/AppRouter';
import { store } from './store/store';
import './styles/index.css';

export default function App() {
  return <Provider store={store}><BrowserRouter><AppRouter /></BrowserRouter></Provider>;
}
